import { useEffect, useRef } from "react";
import * as THREE from "three";

export const GoldSeal = ({ hovered, mouse }) => {
  const mountRef = useRef(null);
  const stateRef = useRef({ hovered: false, mx: 0, my: 0 });

  useEffect(() => {
    stateRef.current.hovered = hovered;
  }, [hovered]);
  useEffect(() => {
    stateRef.current.mx = mouse.x;
    stateRef.current.my = mouse.y;
  }, [mouse]);

  useEffect(() => {
    const mount = mountRef.current;
    const scene = new THREE.Scene();
    const camera = new THREE.PerspectiveCamera(45, 1, 0.1, 100);
    camera.position.z = 6;
    const renderer = new THREE.WebGLRenderer({ alpha: true, antialias: true });
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
    mount.appendChild(renderer.domElement);

    const group = new THREE.Group();
    const goldMat = new THREE.MeshStandardMaterial({ color: 0xfe0000, metalness: 0.85, roughness: 0.28 });
    const torus = new THREE.Mesh(new THREE.TorusGeometry(1.5, 0.22, 32, 96), goldMat);
    group.add(torus);

    const shape = new THREE.Shape();
    for (let i = 0; i < 10; i++) {
      const a = -Math.PI / 2 + (i * Math.PI) / 5;
      const r = i % 2 === 0 ? 1.0 : 0.42;
      const x = Math.cos(a) * r, y = -Math.sin(a) * r;
      if (i === 0) shape.moveTo(x, y);
      else shape.lineTo(x, y);
    }
    shape.closePath();
    const star = new THREE.Mesh(
      new THREE.ExtrudeGeometry(shape, { depth: 0.22, bevelEnabled: true, bevelSize: 0.04, bevelThickness: 0.04 }),
      goldMat
    );
    star.position.z = -0.11;
    group.add(star);
    group.position.y = -5;
    scene.add(group);

    scene.add(new THREE.AmbientLight(0xffffff, 0.35));
    const key = new THREE.DirectionalLight(0xfff2cc, 1.6);
    key.position.set(2, 3, 4);
    scene.add(key);
    const rim = new THREE.PointLight(0xfe0000, 2.2, 20);
    rim.position.set(-3, -2, 3);
    scene.add(rim);

    const resize = () => {
      const w = mount.clientWidth, h = mount.clientHeight;
      renderer.setSize(w, h);
      camera.aspect = w / h;
      camera.updateProjectionMatrix();
    };
    resize();
    window.addEventListener("resize", resize);

    let raf;
    let ty = -5;
    const loop = () => {
      const s = stateRef.current;
      const targetY = s.hovered ? 0 : -5;
      ty += (targetY - ty) * 0.09;
      group.position.y = ty;
      group.rotation.y += ((s.mx * 0.26) - group.rotation.y) * 0.08;
      group.rotation.x += ((-s.my * 0.26) - group.rotation.x) * 0.08;
      group.rotation.z += 0.002;
      renderer.render(scene, camera);
      raf = requestAnimationFrame(loop);
    };
    loop();

    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener("resize", resize);
      renderer.dispose();
      mount.removeChild(renderer.domElement);
    };
  }, []);

  return (
    <div
      ref={mountRef}
      className="absolute inset-0 transition-opacity duration-500"
      style={{ opacity: hovered ? 1 : 0 }}
      data-testid="gold-seal-canvas"
    />
  );
};
